import { useDispatch, useSelector } from "react-redux";

import { PendoMetaFields } from "globalConstants";
import { mapUserProfileToPendo, mapUserProfileToPendoApi } from "mappers";
import { usePendoGetUserProfileQuery } from "queries";
import { pendoActions, pendoDataSelector } from "store";
import {
	getCurrentUserPermissions,
	getCurrentUserRole,
} from "store/user/user.reducer";

const REACT_APP_PENDO_API = process.env.REACT_APP_PENDO_API;

const { Role, Permissions } = PendoMetaFields;

const usePendoInitialize = (isUserLogIn: boolean) => {
	const dispatch = useDispatch();
	const pendo = useSelector(pendoDataSelector);
	const role = useSelector(getCurrentUserRole);
	const permissions = useSelector(getCurrentUserPermissions);

	const isEnabled = isUserLogIn && role?.id && !pendo?.visitor?.id;

	const pendoInit = data => {
		(function (apiKey) {
			(function (p, e, n, d, o: { [key: string]: any } = {}) {
				var v, w, x, y, z;
				o = p[d] = p[d] || {};
				o._q = o._q || [];
				v = [
					"initialize",
					"identify",
					"updateOptions",
					"pageLoad",
					"track",
				];
				for (w = 0, x = v.length; w < x; ++w)
					(function (m) {
						o[m] =
							o[m] ||
							function () {
								o._q[m === v[0] ? "unshift" : "push"](
									[m].concat([].slice.call(arguments, 0)),
								);
							};
					})(v[w]);
				y = e.createElement(n);
				y.async = !0;
				y.src =
					"https://cdn.pendo.io/agent/static/" + apiKey + "/pendo.js";
				z = e.getElementsByTagName(n)[0];
				z.parentNode.insertBefore(y, z);
			})(window, document, "script", "pendo");
		})(REACT_APP_PENDO_API);

		const userData = {
			...data,
			[Role.beName]: role?.name,
			[Permissions.beName]: permissions.map(el => el.displayName),
		};

		dispatch(pendoActions.init(mapUserProfileToPendo(userData)));
		(window as any).pendo.initialize(mapUserProfileToPendoApi(userData));
	};

	usePendoGetUserProfileQuery({
		isEnabled,
		onSuccess: pendoInit,
	});
};

export default usePendoInitialize;
